import { render, staticRenderFns } from "./createJobSeekerView.vue?vue&type=template&id=2723a6b3&scoped=true&"
import script from "./createJobSeekerView.vue?vue&type=script&lang=js&"
export * from "./createJobSeekerView.vue?vue&type=script&lang=js&"
import style0 from "./createJobSeekerView.vue?vue&type=style&index=0&id=2723a6b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723a6b3",
  null
  
)

export default component.exports